{"id":"SelectDeliveryBox","prefabs":{"default":{"children":[{"component":"SelectDeliveryBox","options":"options:*"}]}}}